import { DOWNLOAD_TIMEOUT_MS, NO_HTTP_CACHE, fetchBytesWithTimeout } from "../templates/timeout.js";

const isDesktopWebview = () => "__TAURI_INTERNALS__" in globalThis;

// Browsers sniff raster formats from the bytes, but decode an SVG only from a typed blob.
const blobType = (bytes: Uint8Array) =>
  /<svg[\s>]/i.test(new TextDecoder().decode(bytes.subarray(0, 512))) ? "image/svg+xml" : "";

/** Points `img` at `url` past the HTTP cache (see `NO_HTTP_CACHE`); a blob URL never taints a
 *  canvas. A failed fetch falls back to the URL itself, so the image's own `onerror` still fires.
 *  The desktop webview keeps a plain load: its own fetch pool to the asset host can strand (WS-W). */
export async function loadUncached(img: HTMLImageElement, url: string): Promise<void> {
  if (!/^https?:\/\//i.test(url) || isDesktopWebview()) {
    img.src = url;
    return;
  }
  try {
    const bytes = await fetchBytesWithTimeout(url, NO_HTTP_CACHE, DOWNLOAD_TIMEOUT_MS, "Image download");
    const blobUrl = URL.createObjectURL(new Blob([bytes as BlobPart], { type: blobType(bytes) }));
    const revoke = () => URL.revokeObjectURL(blobUrl);
    img.addEventListener("load", revoke, { once: true });
    img.addEventListener("error", revoke, { once: true });
    img.src = blobUrl;
  } catch {
    img.src = url;
  }
}
